import update from 'immutability-helper';

const INIT_STATE = {
  rows: [],
  unmatched: [],
  loading: false,
  error: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'SET_TRACKING_LOADING':
      return update(state, { loading: { $set: action.payload } });
    case 'SET_TRACKING_ROWS':
      return update(state, { rows: { $set: action.payload }, loading: { $set: false }, error: { $set: null } });
    case 'SET_TRACKING_ERROR':
      return update(state, { error: { $set: action.payload }, loading: { $set: false } });
    case 'SET_TRACKING_UNMATCHED':
      return update(state, { unmatched: { $set: action.payload } });
    default:
      return state;
  }
};
